<template>
	<div class="c-presentation" v-if="data" :class="{'has-action': data.urls, 'is-editing': isSomeoneEditing()}">
		<router-link v-if="data.urls && data.urls.edit" :to="{path: data.urls.edit}" class="st-table__link">
			{{ data.title }}
		</router-link>
	    <span v-else>
	    	{{ data.title}}
	    </span>

		<div v-if="isSomeoneEditing()">
			{{ $t('Someone is currently editing this Presentation. Please try again later.') }}
		</div>

	    <div class="st-able-action" :class="{'st-table-action--active': this.isdeleting}" v-if="data.urls && !isSomeoneEditing()">
			<router-link class="st-table-action__link st-table-action__link--edit" v-if="data.urls.edit" :to="{ name: (master ? 'master-' : '') + 'editor', params: { pid : data.id.toString() }}">{{ $t('Edit') }}</router-link>
	        <router-link class="st-table-action__link st-table-action__link--settings" v-if="data.urls.settings && !simple && !master" :to="{ name: 'presentation-settings', params: { pid : data.id.toString() }}">{{ $t('Settings') }}</router-link>
	        <a class="st-table-action__link st-table-action__link--view" v-if="data.urls.view" :href="data.urls.view" target="_blank">{{ $t('View') }}</a>
	        <a class="st-table-action__link st-table-action__link--view" v-if="data.urls.view && !simple" :href="'mailto:?body=' + data.urls.view">{{ $t('Copy Link') }}</a>
	        <a download :href="data.urls.download" class="st-table-action__link st-table-action__link--download" v-if="data.urls.download && !simple">{{ $t('Download') }}</a>
	        <a @click.prevent="startdeletepresentation" :href="data.urls.edit" class="st-table-action__link st-table-action__link--delete" v-if="data.urls.delete && !simple">{{ $t('Delete') }}</a>
	    </div>

	    <v-tooldown v-if="deleteel && isdeleting" :loading="loading" :type="'delete'" :el="deleteel" :yesno="true" @ok="deletepresentation" @cancel="stopdeletepresentation">
        	<div v-cloak slot="title">{{ $t('Delete Presentation') }}</div>
        	<div v-cloak slot="message">{{ $t('Do you really want to delete this Presentation.') }}</div>
        	<div v-cloak slot="positive">{{ $t('Delete') }}</div>
        </v-tooldown>
	</div>
</template>


<script>
import help_general from '@/helpers/general';
import help_rest from '@/helpers/rest';
import forEach from 'lodash/forEach';
export default {
	name: 'c-presentation',
  	data(){
  		return {
  			loading: false,
  			isdeleting: false,
  			deleteel: false
  		}
  	},
  	computed: {
  		currentUsers(){
  			var presentation_edit_status = this.$store.getters['socket/getFromLive']('presentation_edit_status');
			if(typeof presentation_edit_status[this.data.id] === 'undefined') return false;

  			// forEach(presentation_edit_status[this.data.id], (id) => {

  			// });
  			return true;
  		}
  	},
	props: {
		data: {
			type: Object,
			default(){
				return {};
			}
		},
	    simple: {
			type: Boolean,
			default: false
	    },
	    master: {
			type: Boolean,
			default: false
	    },
	},
	methods: {
		...help_rest,
		isSomeoneEditing(){
			var presentation_edit_status = this.$store.getters['socket/getFromLive']('presentation_edit_status');
			return typeof presentation_edit_status[this.data.id] !== 'undefined' ? presentation_edit_status[this.data.id] : false;
		},
		copyLink(ev){
			ev.preventDefault();
			const href = ev.target.getAttribute('href');
			help_general.copyToClipboard(href);
			this.$emit('copyedLink', href);
		},
		startdeletepresentation(event){
			this.deleteel = event.target;
			this.isdeleting = !this.isdeleting;
		},
		deletepresentation(){
			const self = this;
			self.loading = true;
			this.restdelete(this.$store.getters.channel.urls.presentation.replace(':id:', this.data.id), 'delete-presentation')
			.then(message => {
				self.loading = false;
				self.$emit('delete');
				self.stopdeletepresentation();
			});
		},
		stopdeletepresentation(){
			this.deleteel = false;
			this.isdeleting = false;
		},
	}

}
</script>



// WEBPACK FOOTER //
// src/components/c-presentation.vue